<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <!-- <v-row class="mt-5">
            <v-col cols="12" lg="8" offset-lg="2">
                <v-card class="mb-5">
                    <v-card-text>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row align="center">
            <v-col cols="12" sm="4">
                <v-btn
                    block
                    color="primary"
                    href="/admin/new-parent-store"
                    v-if="this.userRole === 'admin'"
                >Añadir nuevo</v-btn>
            </v-col>
            <v-col cols="12" sm="8">
                <form @submit.prevent="processSearch" style="width:100%" class="d-flex align-center">
                    <v-text-field
                        v-model="txtSearch"
                        label="Buscar tienda..."
                        outlined
                        dense
                        hide-details
                        type="text"
                    ></v-text-field>
                    <v-btn
                        color="primary"
                        type="submit"
                        elevation="2"
                        icon
                        large
                        v-show="txtSearch !== ''"
                        class="ml-2"
                    >
                        <v-icon dark>
                            mdi-magnify
                        </v-icon>
                    </v-btn>
                    <v-btn
                        color="red"
                        icon
                        large
                        v-show="txtSearch !== ''"
                        @click="cleanSearch"
                        class="ml-2"
                    >
                        <v-icon dark>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </form>
            </v-col>
        </v-row>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Lista de usuarios
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            tienda
                        </th>
                        <th class="text-left">
                            Link
                        </th>
                        <th class="text-left">
                            Estado
                        </th>
                        <th class="text-right">
                            Acciones
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in listStores" :key="index">
                        <td>{{ item.title }}</td>
                        <td>
                            <a :href="tmpSlug+item.slug" target="_blank">
                                {{ tmpSlug+item.slug }}
                                <v-icon x-small>mdi-open-in-new</v-icon>
                            </a>
                        </td>
                        <td>
                            <v-chip
                                :color="(item.state)?'green':'red'"
                                small
                                text-color="white"
                            >
                                {{ (item.state)?'Activo':'Inactivo' }}
                            </v-chip>
                        </td>
                        <td class="text-right">
                            <div class="d-flex justify-end">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            icon
                                            :href="`/admin/edit-parent-store/${item.id}`"
                                        >
                                            <v-icon color="grey">
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
        ></v-pagination>
        <!-- end card main -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    props: ["userRole"],
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Tiendas',
                    disabled: false,
                    href: '/admin/parent-stores',
                },
                {
                    text: 'Todos',
                    disabled: true,
                    href: '',
                }
            ],
            tmpSlug: 'https://'+window.location.hostname+'/shop/',
            // list data
            listStores: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            txtSearch: '',
        }
    },
    mounted() {
        this.getListStores()
    },
    methods: {
        /**
         * List categories
         */
        processSearch () {
            this.page = 1
            this.getListStores()
        },
        changePage (event) {
            this.page = event;
            this.getListStores()
        },
        cleanSearch () {
            if (this.txtSearch !== '') {
                this.listStores = []
                this.page = 1
                this.txtSearch = ''
                this.getListStores();
            }
        },
        async getListStores () {
            this.overlay = true
            await axios.post(`/admin/list-parentstores?page=${this.page}&search=${this.txtSearch}`, {})
            .then(response => {
                // console.log(response)
                this.listStores = response.data.data
                this.totalPage = response.data.last_page
                this.pageTable = `Mostrando <strong>${response.data.from??0} - ${response.data.to??0}</strong> de un total de <strong>${response.data.total}</strong>`
                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
                this.overlay = false
            })
        },
    },
}
</script>
